import toast from 'react-hot-toast'

import { useMutation } from '@fv/client-core'
import type { ShareQuoteRequestDto } from '@fv/models'

import { carrierFetch } from '@/utils/carrierFetch'

const shareOpportunity =
  (loadId: string) => async (body: ShareQuoteRequestDto) => {
    await carrierFetch(`/loads/${loadId}/share`, { method: 'POST', body })
    return body.email
  }

export function useShareOpportunity(loadId: string) {
  return useMutation(shareOpportunity(loadId), {
    onSuccess: email => {
      toast.success(`Opportunity shared with ${email}.`)
    },
  })
}
